module.exports = __webpack_public_path__ + "static/media/Manisha_Basra.587c3ff3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Manisha_Basra.pdf
// module id = 44
// module chunks = 0